export default {
  matchPurchaseContract: {
    dialogTitle: '匹配采购合同',
    search: {
      supplier: '供应商',
      supplierPlaceholder: '请选择供应商',
      contractNo: '采购合同号',
      purchaseContractNoPlaceholder: '请选择采购合同号',
      externalContractNo: '外部采购合同号',
      externalPurchaseContractNoPlaceholder: '请输入外部采购合同号',
      settleBatchNumber: '入库批次号',
      warehousingDateStart: '入库日期从',
      warehousingDateEnd: '入库日期到',
      warehousingBatchNoPlaceholder: '请选择入库批次号',
      businessInboundNo: '业务入库单号',
    },
    table: {
      matching: '匹配',
      contractNo: '采购合同编号',
      contractDetailNo: '采购合同行项目号',
      businessInboundBatchNo: '入库批次号',
      businessInboundNo: '业务入库单号',
      returnNo: '退货单号',
      returnDetailNo: '退货单行号',
      inboundCreateDate: '业务入库日期',
      productDesc: '商品描述',
      productUnit: '单位',
      inboundQuantity: '已入库数量',
      inboundUnitPrice: '已入库单价',
      exchangeRate: '入库汇率',
      matchedQuantity: '已匹配数量',
      matchedAavailableQuantity: '可匹配数量',
      matchInboundQuantity: '本次匹配入库数量',
      overShippedQuantity: '溢短装数量',
      invoiceQuantity: '本次收票数量',
      invoiceUnitPrice: '发票单价',
      originalTotalWithoutTaxAmount: '不含税金额',
      taxCode: '税码',
      taxRate: '税率',
      taxAmount: '税额',
      totalAmount: '总额',
    },
  },
};
